import { UserType } from 'store/slices/authSlice';

import axiosPublic from '../config/axiosPublic';

export interface Auth0TokenExchangeResponse {
  refreshToken: string;
  accessToken: string;
  userInfo: UserType;
}

/**
 * Exchange an Auth0 access token for PA-specific JWT tokens.
 *
 * @param auth0Token - The access token obtained from Auth0 PKCE flow
 * @returns PA tokens and user info (same format as login endpoint)
 */
export const exchangeAuth0Token = async (auth0Token: string): Promise<Auth0TokenExchangeResponse> => {
  const response = await axiosPublic.post<Auth0TokenExchangeResponse>('/api/jwt/auth/auth0-exchange/', {
    auth0_token: auth0Token,
  });
  return response.data;
};
